export enum ServiceOption {
	EDIT,
	DUPLICATE
}
